import { appRoutePath } from '../../../util/app-route-path'
import { RouteStacker } from '../../template/RouteStacker'
import { AutRoutes } from '../../../../auth/AutRoutes'
import { SignUpRoutes } from '../../../../../route/SignUpRoutes'
import { B2bRoutes } from 'src/feature/b2b/B2bRoutes'
import { GlobalStyles } from '@mui/material'
import { ColorTokens } from 'src/feature/theme/model/Palette'

export function PublicRoutesStack() {
  return (
    <>
      <GlobalStyles styles={styles.global} />
      <RouteStacker
        redirectToIfNoFound={appRoutePath.authHome}
        routes={[
          AutRoutes,
          SignUpRoutes,
          B2bRoutes,
        ]}
      />
    </>
  )
}

const styles = {
  global: {
    html: {
      backgroundColor: `${ColorTokens.neutral200} !important`,
    },
    body: {
      backgroundColor: `${ColorTokens.neutral200} !important`,
    },
    '#root': {
      backgroundColor: `${ColorTokens.neutral200} !important`,
      minHeight: '100vh',
    },
  },
}
